module.exports = __webpack_public_path__ + "static/media/fitculator-white.456007ea.png";